import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { XCircle } from 'lucide-react';
import './PaymentResult.scss';

const PaymentCancel: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="payment-result-page">
      <div className="container">
        <div className="result-card cancel">
          <div className="result-icon">
            <XCircle size={64} />
          </div>
          <h1>Mokėjimas atšauktas</h1>
          <p>Jūsų mokėjimas buvo atšauktas. Jokia suma nebuvo nuskaičiuota.</p>

          <div className="result-actions">
            <button
              className="btn-primary"
              onClick={() => navigate(-1)}
            >
              Bandyti dar kartą
            </button>
            <button
              className="btn-secondary"
              onClick={() => navigate(user?.user_type === 'employer' ? '/employer/services?mode=employer' : '/employee/services')}
            >
              Grįžti į paslaugas
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
